import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=24a5a9f9&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=24a5a9f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5a9f9",
  null
  
)

export default component.exports